import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './HomeInfo.css';

import loanIcon from '../../assets/images/loan.png';
import savingsIcon from '../../assets/images/saving.png';
import depositIcon from '../../assets/images/deposit.png';

const cards = [
  {
    title: 'Personal & Business Loans',
    image: loanIcon,
    alt: 'Personal and business loans',
    to: '/loans',
  },
  {
    title: 'Checking & Savings Account',
    image: savingsIcon,
    alt: 'Checking and savings accounts',
    to: '/checking',
  },
  {
    title: 'CD Account',
    image: depositIcon,
    alt: 'Certificate of Deposit account',
    to: '/cd',
  },
];

const HomeInfo = () => (
  <section className="home-info">
    <Container className="py-5">
      <h2 className="text-center mb-4 gn-title">Top Products & Services </h2>
      <Row className="g-4 justify-content-center">
        {cards.map((card) => (
          <Col md={4} xs={12} key={card.title}>
            <Card as={Link} to={card.to} className="h-100 home-info-card text-decoration-none">
              <div className="home-info-icon-wrap">
                <img src={card.image} alt={card.alt} className="home-info-icon" />
              </div>
              <Card.Body>
                <Card.Title className="h5 home-info-title mb-0">{card.title}</Card.Title>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  </section>
);

export default HomeInfo;


